import React from "react";
import PropTypes from 'prop-types';
import css from "./style.scss";

const ProgressBar = (props) => {
  const { percent, inactive } = props;
  const displayPercent = Math.round(percent);
  return (
    <div className={`${css.container} ${inactive ? css.inactive : ''}`}>
      <div className={css.section}>
        <div className={`${css.progressBar} ${inactive ? css.progressBarInactive : ''}`} style={{ width: `${percent}%` }} />
      </div>
      <div className={css.percentText}>{displayPercent}%</div>
    </div>
  );
};

ProgressBar.propTypes = {
  percent: PropTypes.number.isRequired,
  inactive: PropTypes.bool,
};

ProgressBar.defaultProps = {
  percent: 0,
  inactive: false,
};

export default ProgressBar;
